import { Record } from 'immutable';

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
export default new Record({
  languageAndLocale: undefined,
  defaultPhoneCountryCode: undefined,
  phoneNumber: undefined,
  twoFactorStatus: undefined,
  unsubscribeLinkType: undefined,
  defaultHome: undefined
}, 'UserAttributes');